import { Carousel } from '../twig/components/Carousel/Carousel';
import { LazyLoader } from '../ts/components/LazyLoader';
import { Collapse } from '../twig/components/Collapse';
import { Menu } from '../twig/components/Menu';
import { FrontPage } from '../twig/pages/front-page/';
import { Share } from './components/Share';
import { Newsletter } from '../twig/modules/newsletter';
(new LazyLoader()).init();
(new Collapse()).init();
(new Menu()).init();
(new FrontPage()).init();
(new Share()).init();
(new Carousel()).init();
(new Newsletter()).init();
